import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Avatar } from '@mui/material';
import AvatarGroup from '@mui/material/AvatarGroup';
import { useTheme } from '@mui/material/styles';
import { iconDefaultAccount } from 'console/left-menu/header/icons/default-icon';
export const NotAnimatedAvatar = memo(function NotAnimatedAvatar(props) {
    const { status_account } = props;
    const theme = useTheme();
    return (_jsx(AvatarGroup, { max: 3, sx: {
            '& .MuiAvatar-root ': {
                border: 'none',
            },
        }, children: iconDefaultAccount(theme).map(({ title, sx, component }) => status_account.filter((i) => i === title).length !== 0 && (_jsx(Avatar, { className: 'profile', sx: sx, children: component }, title))) }));
});
